import React, { useEffect, useState } from 'react'
import { View } from 'styles/reactnative'
import { Input, Select } from 'antd'
import { useAllMembers } from '../../hooks/adminUsers/members'

const { Search } = Input

const AdminSearch = ({
	options,
	searchWords,
	defaultKey,
	defaultKeyValue,
	defaultValue,
}) => {
	const [selectKey, setSelectKey] = useState(defaultKey)
	const [refresh, setRefresh] = useState(false)

	useEffect(() => {
		setSelectKey(defaultKey)
	}, [defaultKey])

	useEffect(() => {
		setTimeout(() => {
			setRefresh(!refresh)
		}, 1000)
	}, [defaultValue])

	const handleChange = (value: string) => {
		setSelectKey(value)
	}
	const searchData = (value: string) => {
		searchWords(selectKey, value)
	}
	return (
		<View style={{ flexDirection: 'row' }}>
			<Search
				addonBefore={
					<Select
						defaultValue={defaultKeyValue}
						style={{
							minWidth: 100,
						}}
						value={selectKey}
						onChange={handleChange}
						options={options}
					/>
				}
				defaultValue={''}
				placeholder="검색어를 입력해주세요."
				onSearch={searchData}
				style={{ width: 400 }}
			/>
		</View>
	)
}

export default React.memo(AdminSearch)
